import React from "react";
import { useParams } from "react-router-dom";
import { connect } from "react-redux";

import DashboardUpdate from "../../Components/Layouts/DashboardUpdate";
import FaqsForm from "../../Components/Forms/FaqsForm";
import { createEntity, updateEntityInfo, setUpdatedRecentlyToFalse } from "../../Redux/FaqsForm/actions";
import { getEntityById } from "../../Redux/Faqs/actions";

function Update({useAuth, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm}) {
  let params = useParams();
  return (
    <DashboardUpdate useAuth={useAuth}>
        <FaqsForm
          isUpdateForm
          {...{params, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm}}
        />
    </DashboardUpdate>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.faqs,
    loginData: state.loginData,
    selectedForm: state.faqsForm,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEntityById: (tokenData, id) => dispatch(getEntityById(tokenData, id)),
    createEntity: (formData, tokenData) => dispatch(createEntity(formData, tokenData)),
    updateEntityInfo: (formData, tokenData, id) => dispatch(updateEntityInfo(formData, tokenData, id)),
    setUpdatedRecentlyToFalse: () => dispatch(setUpdatedRecentlyToFalse()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Update);
